import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from 'libs.nucleus';
export const AIButton = ({ children, ...props }) => {
    return (_jsx("button", { className: `
        box-border inline-flex max-w-full cursor-pointer items-center justify-center border-solid font-medium normal-case outline-0 transition-colors m-0 rounded-lg
        focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:pointer-events-none disabled:text-text-disabled min-h-8 
        border border-neutral-300 text-text-primary hover:bg-neutral-50 active:bg-neutral-300 disabled:bg-neutral-200
        focus-visible:ring-primary-500 disabled:border-0 shadow-sm
        bg-ai-gradient p-0.5
      `, ...props, children: _jsx("div", { className: 'max-w-full truncate box-border flex bg-white rounded-[0.3rem] px-4 py-1', children: _jsx(Text, { as: 'span', size: 'sm', className: 'flex items-center gap-2', children: children }) }) }));
};
